import React from 'react';
import { Form as FinalForm } from 'react-final-form';
import {
    Button, Form, Grid, Icon
} from 'semantic-ui-react';
import { TextField } from '+/components';
import IndexOf from 'lodash/indexOf';
import { useProperty, useUpdateProperty } from '~/properties';

const AmenityConfigForm = props => {

    const { match } = props;
    const { property_id } = match.params;

    const { data: property } = useProperty(property_id);
    const { mutate: updateProperty } = useUpdateProperty();

    const onSubmit = values => {
        const payload = {
            amenity_config: JSON.stringify(values.amenity_config)
        };

        updateProperty({
            id: property_id,
            payload
        });

    };

    const initialValues = {
        amenity_config: property?.amenity_config || [{ ...ruleSchema }]
    };

    return (
        <div style={styles.root}>
            <FinalForm
                validate={validate}
                initialValues={initialValues}
                onSubmit={onSubmit}
                mutators={{
                    addRule: ([value], state, { changeValue }) => {
                        const newState = [...state.formState.values.amenity_config, { ...ruleSchema }];

                        changeValue(state, 'amenity_config', () => newState);
                    },
                    removeRule: ([value], state, { changeValue }) => {
                        const clonedState = [...state.formState.values.amenity_config];
                        clonedState.splice(value, 1);

                        changeValue(state, 'amenity_config', () => clonedState);
                    }
                }}
                render={({
                    handleSubmit, submitting, pristine, values, form: { mutators }
                }) => (
                    <div>
                        <Form onSubmit={handleSubmit}>
                            <Grid>
                                {values.amenity_config.map(({ amenity_name, amenity_price }, i) => (
                                    <Grid.Row key={i}>
                                        <Grid.Column width={7}>
                                            <TextField name={`amenity_config[${i}].amenity_name`} label={'Amenity Name'} />
                                        </Grid.Column>
                                        <Grid.Column width={7}>
                                            <TextField
                                                name={`amenity_config[${i}].amenity_price`}
                                                label={'Amenity Price'}
                                                type='number'
                                                min='0'
                                            />
                                        </Grid.Column>
                                        <Grid.Column textAlign='left' verticalAlign='top' width={2}>
                                            <Icon link name='delete' onClick={() => mutators.removeRule(i)} />
                                        </Grid.Column>
                                    </Grid.Row>
                                ))}
                            </Grid>

                            <div style={styles.addButtonContainer}>
                                <div>
                                    <Button
                                        content='Add Rule'
                                        onClick={e => {
                                            e.preventDefault();
                                            mutators.addRule();
                                        }}
                                    />
                                </div>

                                <div>
                                    <Button content='Submit' disabled={submitting} />
                                </div>
                            </div>
                        </Form>
                    </div>
                )}
            />
        </div>
    );
};

const styles = {
    root: {
        padding: '30px'
    },
    addButtonContainer: {
        marginTop: '20px',
        display: 'flex',
        justifyContent: 'space-between'
    }
};

const ruleSchema = {
    amenity_name: null,
    amenity_price: null
};

const findDuplicates = arr => {
    const array = (
        arr.map(amenity_config => amenity_config.amenity_name)
            .map((val, i, iteratee) => IndexOf(iteratee, val, i + 1))
            .filter(i => i > -1)
    );

    return array;
};

const validate = values => {
    const errors = {
        amenity_config: []
    };

    values.amenity_config.forEach((config, i) => {
        if (!config.amenity_name) {
            if (!errors.amenity_config[i]) {
                errors.amenity_config[i] = {};
            }

            errors.amenity_config[i].amenity_name = 'Required';
        }
        if (config.amenity_price < 0) {
            if (!errors.amenity_config[i]) {
                errors.amenity_config[i] = {};
            }

            errors.amenity_config[i].amenity_price = 'Required';
        }
    });

    const [indexOfDuplicate] = findDuplicates(values.amenity_config);

    if (indexOfDuplicate) {

        if (!errors.amenity_config[indexOfDuplicate]) {
            errors.amenity_config[indexOfDuplicate] = {};
        }
        errors.amenity_config[indexOfDuplicate].amenity_name = 'This amenity already exists in the config.';
    }

    return errors;
};


export default AmenityConfigForm;
